


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VSwitchButton from "@/components/VSwitchButton.vue";
import {
  FEATURE_AGENCIES_COMPETITORS,
  FEATURE_AGENCIES_REPORT,
  FEATURE_AGENCIES_TOP_INVESTORS,
  FEATURE_ALERTS,
  FEATURE_AUDITEL,
  FEATURE_AUDITEL_CUSTOM_FEMALE_4_10,
  FEATURE_AUDITEL_CUSTOM_GUESTS_ADULTS_24_54_KIDS_4_14,
  FEATURE_AUDITEL_CUSTOM_KIDS_4_10,
  FEATURE_AUDITEL_CUSTOM_MALE_4_10,
  FEATURE_AUDITEL_CUSTOM_SORGENIA,
  FEATURE_AUDITEL_CUSTOM_PRIMA_ASSICURAZIONI,
  FEATURE_BREAKS,
  FEATURE_COMPARISON,
  FEATURE_CREATIVITY,
  FEATURE_INVESTORS,
  FEATURE_SPECIAL_INITIATIVES_CLIENTS,
  FEATURE_SPECIAL_INITIATIVES_INVESTORS,
  FEATURE_SPECIAL_INITIATIVES_MARKET,
  FEATURE_SPECIAL_INITIATIVES_TRENDS,
  FEATURE_TIME_SLOTS,
  FEATURES,
  FEATURES_AGENCIES,
  FEATURES_AUDITEL,
  FEATURES_SPECIAL_INITIATIVES,
  FEATURES_AGENTS_MODULE,
  FEATURE_AGENTS_PROFILES_ASSOCIATION,
  FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
  FEATURE_AGENTS_MODULE,
  FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH,
  FEATURE_AGENTS_MATCH_BY_COMPANY,
  FEATURE_AGENTS_MATCH_BY_BRAND,
  FEATURE_AGENTS_MATCH_BY_PRODUCT,
  FEATURE_AGENTS_MATCH_PROBLEM,
  FEATURE_AGENTS_MULTIPLE_PRODUCTS,
  FEATURES_EBIQUITY,
  FEATURE_CURRENCY_UNIT,
} from "@/constants";

export const FEATURE_SELECT_AGENTS_MODULE_MODALITY = "agents_module";
export const FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY =
  "display_advertising";
export const FEATURE_SELECT_SPECIAL_INITIATIVES_MODALITY =
  "special_initiatives";
export const FEATURE_SELECT_AUDITEL_MODALITY = "auditel";
export const FEATURE_SELECT_AGENCIES_MODALITY = "agencies";
export const FEATURE_SELECT_EBIQUITY_MODALITY = "ebiquity";
export type FEATURE_SELECT_MODALITY =
  | typeof FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY
  | typeof FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY
  | typeof FEATURE_SELECT_AUDITEL_MODALITY
  | typeof FEATURE_SELECT_AGENTS_MODULE_MODALITY
  | typeof FEATURE_SELECT_EBIQUITY_MODALITY
  | typeof FEATURE_SELECT_AGENCIES_MODALITY;

@Component({
  components: {
    VSwitchButton,
  },
})
export default class FeatureSelect extends Vue {
  @Prop() readonly value!: string[];
  @Prop({ default: FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY })
  readonly modality!: FEATURE_SELECT_MODALITY;
  @Prop({ default: () => null }) readonly media!: {
    radio: boolean;
    tv: boolean;
  } | null;

  selectedMedia = this.media;
  features: string[] = [];

  created() {
    this.onValueChange(this.value);
  }

  @Watch("value", { immediate: true })
  onValueChange(value: string[]) {
    this.features = [...value];
  }

  @Watch("media", { deep: true })
  onMediaChanged(value: { radio: boolean; tv: boolean }) {
    this.selectedMedia = value;
    if (this.selectedMedia.tv === false) {
      this.onFeatureChange(false, FEATURE_AUDITEL);
    }
  }

  get featureList() {
    if (this.modality === FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY) {
      return FEATURES;
    } else if (this.modality === FEATURE_SELECT_AUDITEL_MODALITY) {
      return FEATURES_AUDITEL;
    } else if (this.modality === FEATURE_SELECT_AGENCIES_MODALITY) {
      return FEATURES_AGENCIES;
    } else if (this.modality === FEATURE_SELECT_AGENTS_MODULE_MODALITY) {
      return FEATURES_AGENTS_MODULE;
    } else if (this.modality === FEATURE_SELECT_EBIQUITY_MODALITY) {
      return FEATURES_EBIQUITY;
    } else {
      return FEATURES_SPECIAL_INITIATIVES;
    }
  }

  get featureAuditel() {
    return FEATURE_AUDITEL;
  }

  get isAuditelDisabled() {
    return this.selectedMedia?.tv === false;
  }

  /**
   *  Business meaning of the flags:
   *  agents_match_by_company => Adc Company <-> Client Company
   *  agents_match_by_brand => Adc Brand <-> Client Company
   *  agents_match_by_product => Adc Product <-> Client Product
   */
  get featuresMatchlevel(): string[] {
    return [
      FEATURE_AGENTS_MATCH_BY_COMPANY,
      FEATURE_AGENTS_MATCH_BY_BRAND,
      FEATURE_AGENTS_MATCH_BY_PRODUCT,
    ];
  }

  get featureDescriptions() {
    const descriptions: {
      [key: string]: string;
    } = {};

    if (this.modality === FEATURE_SELECT_DISPLAY_ADVERTISING_MODALITY) {
      descriptions[FEATURE_INVESTORS] = "Top investors";
      descriptions[FEATURE_COMPARISON] = "Confronto";
      descriptions[FEATURE_ALERTS] = "Alert feed";
      descriptions[FEATURE_TIME_SLOTS] = "Giorni/Fasce orarie";
      descriptions[FEATURE_CREATIVITY] = "Creatività";
      descriptions[FEATURE_BREAKS] = "Posizionamento Break";
    } else if (this.modality === FEATURE_SELECT_AUDITEL_MODALITY) {
      descriptions[FEATURE_AUDITEL] = "Auditel";
      descriptions[FEATURE_AUDITEL_CUSTOM_FEMALE_4_10] =
        "Target Girls 4-10 guest";
      descriptions[FEATURE_AUDITEL_CUSTOM_MALE_4_10] = "Target Boys 4-10 guest";
      descriptions[FEATURE_AUDITEL_CUSTOM_SORGENIA] = "Target Sorgenia";
      descriptions[FEATURE_AUDITEL_CUSTOM_KIDS_4_10] = "Target Kids 4-10 guest";
      descriptions[FEATURE_AUDITEL_CUSTOM_GUESTS_ADULTS_24_54_KIDS_4_14] =
        "Target Adu 25-54 figli 4-14 guest";
      descriptions[FEATURE_AUDITEL_CUSTOM_PRIMA_ASSICURAZIONI] =
        "Target Prima Assicurazioni";
    } else if (this.modality === FEATURE_SELECT_AGENCIES_MODALITY) {
      descriptions[FEATURE_AGENCIES_COMPETITORS] = "Approfondimento alert";
      descriptions[FEATURE_AGENCIES_REPORT] = "Custom Report";
      descriptions[FEATURE_AGENCIES_TOP_INVESTORS] = "Top Investors";
    } else if (this.modality == FEATURE_SELECT_AGENTS_MODULE_MODALITY) {
      descriptions[FEATURE_AGENTS_PROFILES_ASSOCIATION] =
        "Associazione anagrafiche";
      descriptions[FEATURE_AGENTS_PRINCIPALS_MANAGEMENT] = "Gestione capofila";
      descriptions[FEATURE_AGENTS_MODULE] = "Dati modulo agenti";
      descriptions[FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH] =
        "Importer storico (off: attualizzato)";
      descriptions[FEATURE_AGENTS_MATCH_BY_COMPANY] = "Match per azienda ADC";
      descriptions[FEATURE_AGENTS_MATCH_BY_BRAND] = "Match per brand ADC";
      descriptions[FEATURE_AGENTS_MATCH_BY_PRODUCT] = "Match per prodotto ADC";
      descriptions[FEATURE_AGENTS_MATCH_PROBLEM] =
        "Gestione Conflitto Abbinamento Prodotti";
      descriptions[FEATURE_AGENTS_MULTIPLE_PRODUCTS] = "Ass. Prodotti Multipli";
    } else if (this.modality == FEATURE_SELECT_EBIQUITY_MODALITY) {
      descriptions[FEATURE_CURRENCY_UNIT] = "Valori Ebiquity";
    } else {
      descriptions[FEATURE_SPECIAL_INITIATIVES_MARKET] = "Mercato";
      descriptions[FEATURE_SPECIAL_INITIATIVES_CLIENTS] = "Clienti";
      descriptions[FEATURE_SPECIAL_INITIATIVES_TRENDS] = "Trends";
      descriptions[FEATURE_SPECIAL_INITIATIVES_INVESTORS] = "Top investors";
    }

    return descriptions;
  }

  isFeatureActive(feature: string) {
    return this.features.indexOf(feature) != -1;
  }

  isFeatureMatchLevel(feature: string): boolean {
    return this.featuresMatchlevel.includes(feature);
  }

  removeAgentMatchFeatures() {
    this.features = this.features.filter(
      (f) => !this.featuresMatchlevel.includes(f)
    );
  }

  onFeatureChange(value: boolean, feature: string) {
    if (value) {
      if (!this.isFeatureActive(feature)) {
        if (this.isFeatureMatchLevel(feature)) {
          this.removeAgentMatchFeatures();
        }

        this.features.push(feature);
      }
    } else {
      const index = this.features.indexOf(feature);

      if (index != -1) {
        this.features.splice(index, 1);
      }
    }

    this.$emit("input", [...this.features]);
  }
}
